import { IFile } from '@repo/toolkit/types'

import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function uploadAffectedStaffSalariesExcel(file: IFile) {
  return restApiClient.url(API.affectedStaffs.uploadAffectedStaffSalariesExcel.url).post({ file })
}
